<template>
  <div data-grm-comp="RoomCBTLogDetail" class="room-cbt-modal-component">
    <div class="room-cbt-modal flex flex-col">
      <div class="room-cbt-header">
        <h6>출제 이력 상세 정보</h6>
        <GrmCloseBtn @click="onClose" />
      </div>
      <div class="mt-6 min-h-0 flex-1 overflow-y-auto">
        <p class="text-2xl font-bold">{{ cbtLog.roomCbtTitle }}</p>
        <RoomCBTLogInfo class="mt-4" />
        <h6 class="mt-8 font-bold">수강생 제출 결과</h6>
        <RoomCBTLogUserList class="mt-4" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import dayjs from "dayjs";
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn.vue";
import RoomCBTLogInfo from "@/components/Room/CBT/RoomCBTLogInfo.vue";
import RoomCBTLogUserList from "@/components/Room/CBT/RoomCBTLogUserList.vue";

export default {
  name: 'RoomCBTLogDetail',
  components: {
    GrmCloseBtn,
    RoomCBTLogInfo,
    RoomCBTLogUserList,
  },
  computed: {
    ...mapState('cbt', [
      'cbtLog',
    ]),
    ...mapGetters('cbt', [
      'getRoomCBTLogTotalScore',
    ]),

    duration() {
      return duration => {
        const hour = Math.floor(duration / 3600);
        const minute = Math.floor((duration % 3600) / 60);
        const second = duration % 60;
        return `${hour ? hour + this.$t('common.hour') + ' ' : ''}${minute ? minute + this.$t('common.minute') + ' ' : ''}${second ? second + this.$t('common.second') : ''}`;
      }
    }
  },
  methods: {
    dayjs,
    onClose() {
      this.$modal('RoomCBTLogDetail')
    },
  }
}
</script>

<style lang="scss" scoped>
.room-cbt-modal-component {
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  z-index: 4;
  white-space: pre-line;
}
.room-cbt-modal {
  position: relative;
  width: 960px;
  height: 90vh;
  padding: 30px 30px 50px 30px;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}
.room-cbt-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  h6 {
    font-size: 18px;
    font-weight: bold;
  }
}
.room-cbt-list-wrapper {
  margin-top: 16px;
}

// Mobile
[grm-device-mobile]{
  .room-cbt-modal-component {
    left: 0;
    .room-cbt-modal {
      width: 100%;
      height: 100%;
      max-height: none;
      border-radius: 0;
      .room-cbt-contents {
        height: calc(100% - 50px);
      }
    }
  }
}
</style>